import { useEffect, useState } from 'react'

// local imports
import useDidMountEffect from 'utils/useDidMountEffect'
import RequestHomeOfficeService from '../../../service/RequestHomeOfficeService'
import { IRemoteReservationResponse, ReservationStatus } from '../../../types/RemoteReservationRequest'

export default function useRemoteOfficeNotification() {
  const [data, setData] = useState<IRemoteReservationResponse[] | undefined>([])
  const [loading, setLoading] = useState<boolean>(false)

  // Sayfa tarih filtresi OLMADAN, yalnızca "Beklemede" (status=1) taleplerle açılır.
  // Tarihler undefined → getFilteredList'e gönderilmez → backend tarih kısıtı uygulamaz (tüm bekleyenler).
  // Kullanıcı filtreden tarih seçtiğinde liste (ve bildirim sayısı) buna göre daralır.
  const [selectedStatus, setSelectedStatus] = useState<ReservationStatus[]>([1])
  const [endDate, setEndDate] = useState<Date | any | undefined>(undefined)
  const [startDate, setStartDate] = useState<Date | any | undefined>(undefined)

  /* Start - End Date validations?... */
  useDidMountEffect(() => startDate > endDate && setEndDate(startDate), [startDate])
  useDidMountEffect(() => endDate < startDate && setStartDate(endDate), [endDate])

  /* ########## Fetch Campus Services Reservations List ########## */
  const reqParams = {
    reservationStatusIds: selectedStatus || 1,
    startDate: startDate,
    endDate: endDate,
  }
  const fetchTableList = () => {
    setLoading(true)
    RequestHomeOfficeService.getFilteredList(reqParams)
      .then((response) => {
        const respData = response.data.map((dt) => ({
          ...dt,
          _nameSurname: `${dt.employeeName} ${dt.employeeSurname}`,
        }))
        setData(respData)
        // Filtre değiştiğinde bildirim sayısını güncelle
        window.dispatchEvent(new CustomEvent('updatePendingApprovalCount', { detail: { startDate, endDate } }))
      })
      .catch((err) => console.log(err))
      .finally(() => setLoading(false))
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => fetchTableList(), [])

  return {
    selectedStatus,
    setSelectedStatus,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    /* Campus Services */
    fetchTableList,
    data,
    loading,
  }
}
